import React from 'react';

import {labels} from '../../../../../../../util/utils';

import OutputText from '@ey/canvascoreservices/OutputText';

import Tooltip from '../../../../../../CoreWrappers/Tooltip';
import Checkbox from '../../../../../../CoreWrappers/Checkbox';
import LoadingWrapper from '../../../../../../CoreWrappers/LoadingWrapper';

const prop = 'Checkbox';

export const config = (handleChange) => ({
	id: `${prop}Column`,
	propName: 'id',
	width: 'var(--px-60)',
	customCell: (item) => {
		const checked = item.isSelected;

		const renderCheckBox = () => {
			const props = {
				id: item.id,
				disabled: item.disabled,
				checked,
				value: checked,
				onChange: () => handleChange(item.id)
			};

			return <Checkbox {...props} />;
		};

		if (item.disabled) {
			const toolTipProps = {
				trigger: renderCheckBox(),
				allowClick: true
			};

			return (
				<Tooltip {...toolTipProps}>
					<OutputText body2 light maxWidth="var(--px-700)" wordBreak={true}>
						{labels.disabledRegionComponentTeamRiskLabel}
					</OutputText>
				</Tooltip>
			);
		}

		return (
			<LoadingWrapper isLoading={item?.isLoading} blockContent loaderSize="xs" spacing="none">
				{renderCheckBox()}
			</LoadingWrapper>
		);
	}
});
